import React from 'react'
import FormGroup from '../FormGroup/FormGroup'
import FormInput from '../FormInput/FormInput'
import './FormSelect.css'

function FormGroupInput({
    className,
    errors,
    id,
    label,
    name,
    required,
    as = 'input',
    children,
    ...rest
}) {
    return (
        <FormGroup
            className={className}
            errors={errors}
            id={id}
            label={label}
            required={required}
        >
            {as === 'select' ? (
                <select
                    id={id}
                    name={name}
                    {...rest}
                >
                    {children}
                </select>
            ) : (
                <FormInput
                    id={id}
                    name={name}
                    errors={errors}
                    {...rest}
                />
            )}
        </FormGroup>
    )
}

export default FormGroupInput
